import AppConstants from '../constants/appConstants';
import { UserFactory } from '../factories/user.factory';

function getMainDomain(hostname = window.location.hostname) {
  const parts = hostname.split('.');
  return parts.slice(-2).join('.');
}

function getCookieEnv(cookie, hostname = window.location.hostname) {
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('sandbox')) {
    return `instacarro::${cookie}::sandbox`;
  }

  return `instacarro::${cookie}::prod`;
}

function readCookie(name) {
  const prefix = `${name}=`;
  const raw = document.cookie.split('; ').find(c => c.startsWith(prefix));

  if (!raw) return null;

  const value = raw.slice(prefix.length);
  try {
    return decodeURIComponent(value);
  } catch (err) {
    return null;
  }
}

export function saveToken(token) {
  localStorage.setItem(`instacarro::${AppConstants.localStorage.token}`, JSON.stringify(token));

  const maxAge = Number.isFinite(token?.expires) ? token.expires : 315360000;

  document.cookie = [
    `${getCookieEnv(AppConstants.localStorage.token)}=${encodeURIComponent(JSON.stringify(token))}`,
    `domain=.${getMainDomain()}`,
    'path=/',
    'secure',
    'samesite=lax',
    `max-age=${maxAge}`,
  ].join('; ');
}

export function getToken() {
  let token = {};
  try {
    token = JSON.parse(localStorage.getItem(`instacarro::${AppConstants.localStorage.token}`));

    if (!token) {
      const raw = readCookie(getCookieEnv(AppConstants.localStorage.token));
      if (raw) {
        token = JSON.parse(raw);
      }
    }
  } catch (err) {}
  return token;
}

export function clearToken() {
  return [
    AppConstants.localStorage.token,
    AppConstants.localStorage.buyerId,
    'pusherTransportTLS',
  ].map(item => {
    document.cookie = [
      `${getCookieEnv(item)}=`,
      `domain=.${getMainDomain()}`,
      'path=/',
      'max-age=0',
    ].join('; ');
    localStorage.removeItem(`instacarro::${item}`);
  });
}

export function getUser(from) {
  const token = from();
  let userData = {};

  if (token !== null) {
    try {
      const base64Url = token.access_token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      userData = JSON.parse(window.atob(base64));
    } catch (err) {}
  }
  return UserFactory.CreateUser(userData);
}

export function getLocalUser() {
  return getUser(() => getToken());
}

export function saveBuyerId(buyerId) {
  localStorage.setItem(`instacarro::${AppConstants.localStorage.buyerId}`, buyerId);
  document.cookie = [
    `${getCookieEnv(AppConstants.localStorage.buyerId)}=${encodeURIComponent(buyerId)}`,
    `domain=.${getMainDomain()}`,
    'path=/',
    'secure',
    'samesite=lax',
    `max-age=315360000`,
  ].join('; ');
}

export function getBuyerId() {
  let buyerId = localStorage.getItem(`instacarro::${AppConstants.localStorage.buyerId}`);

  if (!buyerId) {
    buyerId = readCookie(getCookieEnv(AppConstants.localStorage.buyerId));
  }

  return buyerId;
}
